import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import { Svg } from '../../base';
const IconButtonFC = ({ icon, variant = 'ghost', isDisabled, onClick }) => {
    return (_jsx(ChakraIconButton, { size: "smSquare", "aria-label": "", variant: variant, icon: typeof icon === 'string' ? _jsx(Svg, { size: "s12", name: icon }) : icon, isDisabled: isDisabled, onClick: onClick }));
};
export const IconButton = memo(IconButtonFC);
//# sourceMappingURL=IconButton.js.map